// src/assets/data/cursos/cripto-blockchain/en/modulo-2.js
import banner from "../../../courses/module-2/img2.png";

const modulo2 = {
  courseId: "cripto-blockchain",
  id: "modulo-2",
  title: "🧩 MODULE 2: Blockchain for beginners",
  estimatedDuration: "1 hour 30 minutes",
  format: "Reading + knowledge check activity",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objective",
      content: [
        "Understand what blockchain is, how transactions are validated within this technology, and why this foundation is so important for the Web3 world to work.",
      ],
    },
    {
      id: "definicion",
      navLabel: "What is blockchain?",
      title: "🔍 What is a blockchain?",
      content: [
        {
          type: "paragraph",
          text: "A blockchain is like a giant, public, shared digital record. Imagine a notebook where each page is a block, and all pages are connected one after another, forming a chain.",
        },
        {
          type: "paragraph",
          text: "Instead of being stored on a single computer or in a bank, this notebook is distributed across thousands of computers, called nodes, around the world. Everyone has an identical copy.",
        },
        {
          type: "paragraph",
          text: "Every time someone performs an action, such as sending a cryptocurrency, that action is written on the next page of the book, meaning a block. Once written and verified, no one can delete or change it.",
        },
        {
          type: "paragraph",
          text: "📌 What kind of information can a blockchain contain?",
        },
        {
          type: "list",
          items: [
            "Financial transactions, such as cryptocurrency payments",
            "Ownership of digital objects, such as NFTs or collectibles",
            "Smart contracts",
            "Identification data or medical history",
          ],
        },
      ],
    },
    {
      id: "transaccion",
      navLabel: "Transaction",
      title: "🔁 How does a blockchain transaction work?",
      content: [
        "Here is a step-by-step example, explained through a simple story:",
        {
          type: "orderedList",
          items: [
            "Ana wants to send 10 USDC (Note 1) to Diego.",
            "She uses her wallet to create the transaction.",
            "The transaction is sent to the blockchain network.",
            "The nodes verify the balance and digital signature.",
            "It is grouped into a new block.",
            "The block is validated and added to the chain.",
            "Diego receives the 10 USDC in his wallet.",
          ],
        },
        "Note 1 -> “USDC is a stable cryptocurrency, similar to a digital dollar.”",
        {
          type: "paragraph",
          text: "🧠 What makes this so secure?",
        },
        {
          type: "list",
          items: [
            "All blocks have a unique code, like a digital fingerprint.",
            "That code depends on the content of the block and the previous block.",
            "If someone tries to change even one letter in a block, the code changes and the network rejects it.",
          ],
        },
      ],
    },
    {
      id: "descentralizacion",
      navLabel: "Decentralization",
      title: "🤝 What is decentralization?",
      content: [
        {
          type: "paragraph",
          text: "Decentralization means there is no single company or person controlling everything.",
        },
        {
          type: "paragraph",
          text: "In a blockchain, everyone who participates in the network helps keep it alive and secure.",
        },
        {
          type: "paragraph",
          text: "🧠 Comparison:",
        },
        {
          type: "list",
          items: [
            "In a traditional bank, your data is stored on that company’s servers.",
            "In blockchain, data is distributed among thousands of users, who monitor each other so no one can cheat.",
          ],
        },
      ],
    },
    {
      id: "consenso",
      navLabel: "Consensus",
      title: "🔐 What is consensus?",
      content: [
        {
          type: "paragraph",
          text: "When a new transaction appears, the network needs to agree on whether it is valid.",
        },
        {
          type: "paragraph",
          text: "This process is called a consensus mechanism.",
        },
        {
          type: "paragraph",
          text: "🔄 Two common ways to reach consensus:",
        },
        {
          type: "table",
          headers: ["Method", "How does it work?", "Example"],
          rows: [
            [
              "Proof of Work",
              "Nodes compete by solving mathematical puzzles",
              "Bitcoin",
            ],
            [
              "Proof of Stake",
              "The more coins someone has, the higher their chance of validating",
              "Ethereum today, Solana",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🧠 Fun fact: In Proof of Stake, the more the network trusts you, because you hold more coins or have a good reputation, the more likely you are to validate a block and earn rewards.",
        },
      ],
    },
    {
      id: "ejemplos",
      navLabel: "Real examples",
      title: "🏢 Real-world examples",
      content: [
        {
          type: "orderedList",
          items: [
            "IBM + Maersk: they use blockchain to track shipping containers. This helps reduce fraud and errors in international logistics.",
            "Visa + Stellar: they are working together to enable cheaper and faster international payments using blockchain.",
            "Hospitals: blockchains are being tested to store medical records, helping prevent data from being lost or altered.",
          ],
        },
      ],
    },
    {
      id: "videos",
      navLabel: "Videos",
      title: "📺 Recommended videos",
      content: [
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=Yn8WGaO__ak",
          text: "🎥 What is Blockchain? – Cripto en Minutos",
        },
      ],
    },
    {
      id: "lecturas",
      navLabel: "Complementary readings",
      title: "📚 Complementary readings",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/what-is-blockchain-and-how-does-it-work",
          text: "Binance Academy – How does blockchain work?",
        },
        {
          type: "link",
          href: "https://es.cointelegraph.com/learn/articles/how-does-blockchain-work-a-beginners-guide-to-blockchain-technology",
          text: "Cointelegraph – Beginner’s guide to blockchain",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Activity",
      title: "✅ Knowledge check activity",
      content: [
        "Title: The life cycle of a blockchain transaction",
        {
          type: "paragraph",
          text: "Instructions:",
        },
        {
          type: "paragraph",
          text: "Create a small visual diagram in Google Docs where you explain the 7 steps from the moment a person starts a transaction until it is validated on the chain.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Quote of the day",
      title: "🧠 Quote of the day",
      content: [
        "“Blockchain is not just technology. It is digital trust built by thousands of people.”",
      ],
    },
  ],
};

export default modulo2;
